import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Note } from '../../shared/models';

/**
 * Singleton class to handle events related with the insights page
 */
@Injectable()
export class InsightsEventsService {

  public openModal$ = new Subject<any>();
  public openInsightEmailModal$ = new Subject<any>();
  public collapseSections$ = new Subject<null>();
  public openNotesSection$ = new Subject<{section: boolean, noteId: number}>();
  public updateInsightSectionCounter$ = new Subject<{section: string, value: number}>();
  public autoSaveDraftNotifier$ = new Subject<Note>();

  constructor() { }

  /**
   * Fired on modal open
   * @param {T} data: record from the list on edit
   */
  public openModal<T> (data?: T) {
    this.openModal$.next(data);
  }

  /**
   * Notifies the milestone form modal to open
   */
  public openInsightsEmailModal (): void {
    this.openInsightEmailModal$.next(undefined);
  }

  /**
   * Used to notify subscribers and update the section counter
   * @param updatedValue: new counter value to display
   */
  public updateInsightSectionCounter (updatedValue: {section: string, value: number}) {
    this.updateInsightSectionCounter$.next(updatedValue);
  }

  /**
   * Emits an event to notify the text content component about auto save
   * @param data
   */
  public autoSaveDraftNotifier (data?: Note) {
    this.autoSaveDraftNotifier$.next(data);
  }
}
